import React from 'react'
import { Text, Flex } from 'pcln-design-system'
import { Cars, Pin, Flights, CityView } from 'pcln-icons'
import { GetItemPropsOptions } from 'downshift'
import { LOCATION_SEARCH_TYPE } from '@/types'
import DropdownItem from './DropdownItem'

type SearchItemNearbyAirport = {
  isItemSelected: boolean
  index: number
  getItemProps: (
    options: GetItemPropsOptions<LOCATION_SEARCH_TYPE>
  ) => Record<string, unknown>
  item: LOCATION_SEARCH_TYPE & { skipFeedbackCall?: boolean }
  gaTracking?: () => void
  isMobile: boolean
  nearbyAirportsFeatureEnabled?: boolean
}

function SearchItemNearbyAirport({
  isItemSelected,
  index,
  getItemProps,
  item,
  nearbyAirportsFeatureEnabled,
  isMobile
}: SearchItemNearbyAirport) {
  const iconName = item.type
  const iconDesc = `${iconName}-${index}`
  const ICONS: { [key: string]: unknown } = {
    PARTNER_LOC: Cars,
    POI: Pin,
    AIRPORT: Flights,
    CITY: CityView
  }
  const Icon = ICONS[iconName] ?? Pin
  const displayText = item.itemName
  let displayComponent
  if (nearbyAirportsFeatureEnabled && item.proximity) {
    displayComponent = (
      <Flex flexDirection="column" py={2}>
        <Text textStyle="subheading5" mb={1}>
          {item.displayName}
        </Text>
        <Text textStyle="subheading6" color="text.tint">
          {item.cityName} - {Math.round(item.proximity * 10) / 10} Miles away
        </Text>
      </Flex>
    )
  } else {
    displayComponent = (
      <Text textStyle="subheading5" py={3} mr={2}>
        {displayText}
      </Text>
    )
  }

  return (
    <DropdownItem
      isHighlighted={isItemSelected}
      {...getItemProps({
        item,
        index
      })}
      isMobile={isMobile}
    >
      <Icon
        color="primary"
        mx={2}
        aria-label={iconName}
        desc={iconName}
        descId={`${iconDesc}_ICON`}
        title={iconName}
        titleId={iconDesc}
        size={24}
      />
      {displayComponent}
    </DropdownItem>
  )
}

export default SearchItemNearbyAirport
